(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const originalPositions = new WeakMap();

  function syncProductMedia() {
    if (document.querySelector('.product__info-container')) {
      document.documentElement.classList.add('bw-product-page');
    }

    document.querySelectorAll('.product').forEach((product) => {
      const info = product.querySelector('.product__info-wrapper product-info');
      const media =
        product.querySelector(':scope > .product__media-wrapper') ||
        info?.querySelector(':scope > .product__media-wrapper');

      if (!info || !media) return;

      if (!originalPositions.has(media)) {
        const marker = document.createComment('bamboo-product-media-position');
        media.parentNode.insertBefore(marker, media);
        originalPositions.set(media, marker);
      }

      if (mobileQuery.matches) {
        const productForm = info.querySelector('product-form.product-form');
        const buyBlock = productForm?.parentElement;

        if (buyBlock && media.parentNode !== info) {
          buyBlock.after(media);
        }
      } else {
        const marker = originalPositions.get(media);
        if (marker?.parentNode && media.previousSibling !== marker) {
          marker.after(media);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductMedia, { once: true });
  } else {
    syncProductMedia();
  }

  mobileQuery.addEventListener?.('change', syncProductMedia);
  document.addEventListener('shopify:section:load', syncProductMedia);
})();
